import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';

import { TThunkDispatch } from '../../../../types/redux';
import { setOverallScore as setOverallScoreAction } from '../../../../actions/newReview';
import { setPoliteScore as setPoliteScoreAction } from '../../../../actions/newReview/politeScoreActions';
import { setPriceAndQualityScore as setPriceAndQualityScoreAction } from '../../../../actions/newReview/priceAndQuality';
import { setLocationScore as setLocationScoreAction } from '../../../../actions/newReview/locationScoreActions';
import { setComfortAndApplianceScore as setComfortAndApplianceScoreAction } from '../../../../actions/newReview/comfortAndApplianceScoreActions';
import { setCleaningScore as setCleaningScoreAction } from '../../../../actions/newReview/cleaningScoreActions';
import {
  getCleaning,
  getComfortAndAppliance,
  getLocation,
  getOverallScore,
  getPolite,
  getPriceAndQuality,
} from '../../../../selectors/newReview/scores';

export function useRatingsContainer() {
  const dispatch = useDispatch<TThunkDispatch>();

  const overallScore = useSelector(getOverallScore);
  const polite = useSelector(getPolite);
  const priceAndQuality = useSelector(getPriceAndQuality);
  const location = useSelector(getLocation);
  const comfortAndAppliance = useSelector(getComfortAndAppliance);
  const cleaning = useSelector(getCleaning);

  const setOverallScore = React.useCallback((value: number) => {
    dispatch(setOverallScoreAction(value));
  }, []);
  const setPoliteScore = React.useCallback((value: number) => {
    dispatch(setPoliteScoreAction(value));
  }, []);
  const setPriceAndQualityScore = React.useCallback((value: number) => {
    dispatch(setPriceAndQualityScoreAction(value));
  }, []);
  const setLocationScore = React.useCallback((value: number) => {
    dispatch(setLocationScoreAction(value));
  }, []);
  const setComfortAndApplianceScore = React.useCallback((value: number) => {
    dispatch(setComfortAndApplianceScoreAction(value));
  }, []);
  const setCleaningScore = React.useCallback((value: number) => {
    dispatch(setCleaningScoreAction(value));
  }, []);

  return React.useMemo(
    () => ({
      overallScore,
      polite,
      priceAndQuality,
      location,
      comfortAndAppliance,
      cleaning,

      setOverallScore,
      setPoliteScore,
      setPriceAndQualityScore,
      setLocationScore,
      setComfortAndApplianceScore,
      setCleaningScore,
    }),
    [overallScore, polite, priceAndQuality, location, comfortAndAppliance, cleaning],
  );
}
